(function(window, document) {
'use strict';
if ( window.location !== window.parent.location ) {
	document.querySelector('html').classList.add('embedded-form');
}

window.addEventListener('DOMContentLoaded', initializeConfirmationPage);

function initializeConfirmationPage() {
	var responseData = JSON.parse(sessionStorage.getItem('edlioFormResponse'));
	responseData.orderSummary = sessionStorage.getItem('edlioOrderSummary');
	sessionStorage.removeItem('edlioOrderSummary');

	// If the user navigates directly to the confirmation page without submitting
	// the form, they will be greeted with a message asking them to fill it out
	if ( !responseData ) {
		document.getElementById('confirmation_page').classList.add('hidden');
		document.getElementById('no_submissions_message').classList.remove('hidden');
		return;
	}

	var responseId = responseData.responseId;

	sessionStorage.removeItem('edlioFormResponse');

	if ( window.edlio.showResponseSummary ) {
		populateResponseData(responseData, responseId);
	}

	var editLink = document.getElementById('edit_response_link');

	if ( editLink ) {
		editLink.addEventListener('click', function() {
			sessionStorage.setItem('edlioFormEditResponseData', JSON.stringify(responseData));
			window.location.href = ' /apps/form/' + responseData.formId + '?_=' + new Date().getTime();
		});
	}

	document.getElementById('confirmation_page').classList.remove('loading');
}

function formatValueToLocale(value) {
	if (value === undefined) {
		return;
	}
	return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2 }); // use default host formatting and always display decimals
}

function populateResponseData(responseData, responseId) {
	var summaryElement = document.getElementById('response_summary');
	var fieldList = document.createElement('ul');
	var paymentInfoBlock = document.createElement('ul');

	responseData.fields.forEach(function(fieldData) {
		var field = document.createElement('li');
		field.classList.add('field');

		var label = document.createElement('div');
		label.classList.add('label');

		var value = document.createElement('div');
		value.classList.add('value');

		if ( fieldData.type === 'FILE_UPLOAD_INPUT' ) {
			label.innerText = fieldData.label;

			if (fieldData.values) {
                var valueList = document.createElement('ol');
				fieldData.values.forEach(function(attachment) {
					var item = document.createElement('li');
					var anchorTag = document.createElement('a');
					anchorTag.setAttribute('href', attachment.url);
					anchorTag.setAttribute('target', '_blank');
					anchorTag.textContent = attachment.name;
					item.appendChild(anchorTag);
					valueList.appendChild(item);
                    value.appendChild(valueList);
				});
			} else {
                value.innerHTML = '---';
			}
		} else if ( fieldData.group ) {
			if (fieldData.group.type == "TABLE_GROUP") {
				label.innerText += fieldData.group.tableLabel ? fieldData.group.tableLabel : "N/A";
				label.innerText += fieldData.group.label ?  " " + "[" + fieldData.group.label + "]" : " " + "[" + "N/A" + "]";
			} else {
				label.innerText = fieldData.group.label ? fieldData.group.label : "";
			}

			var valueList = document.createElement('ul');
			var item;

			if (fieldData.selections.length) {
				for( var i = 0; i < fieldData.selections.length; i++ ) {
					item = document.createElement('li');

					if (fieldData.group.type == "MULTI_CHOICE_PAY_GROUP") {
						var choice = fieldData.selections[i];
						var formattedCost = formatValueToLocale(choice.cost);
						//TODO: Replace hard coded $ with currency variable
						var displayValue = choice.title ? "$" + " " + formattedCost + " - " + choice.title : "$" + " " + formattedCost;
						item.appendChild(document.createTextNode(displayValue));
					} else {
						item.appendChild(document.createTextNode(fieldData.selections[i].value));
					}

					valueList.appendChild(item);
				}
			} else {
				item = document.createElement('li');
				item.innerHTML = '---';
				valueList.appendChild(item);
			}

			value.appendChild(valueList);
		} else {
			label.innerText = fieldData.label;
			if (fieldData.type === 'PAYMENT_ITEM') {
				let fieldCost, formattedCost;
				if(responseData.selectedItems && responseData.selectedItems.length > 0){
					for (let item = 0; item < responseData.selectedItems.length; item++) {
						if (responseData.selectedItems[item].id == fieldData.uniqueId) {
							fieldCost = responseData.selectedItems[item].cost;
							formattedCost = formatValueToLocale(fieldCost);
							label.innerText += ', $' + formattedCost + ' each';
							break;
						}
					}
				}
			}
			if (fieldData.type === 'TEXT_BOX_EXTRA') {
				label.classList.add('section-title');
				value.classList.add('hidden');
			} else if (fieldData.type === 'USER_SIGNATURE') {
				const nameField = field.cloneNode();
				const nameLabel = label.cloneNode();
				const nameValue = value.cloneNode();
				nameLabel.innerHTML = 'Name of signer';
				nameValue.innerText = fieldData.value.userFullName;
				nameField.appendChild(nameLabel)
				nameField.appendChild(nameValue)

				const signedAt = moment(fieldData.value.signedAt).format('MM/DD/YYYY');
				const dateField = field.cloneNode();
				const dateLabel = label.cloneNode();
				const dateValue = value.cloneNode();
				dateLabel.innerHTML = 'Date signed';
				dateValue.innerText = signedAt;
				dateField.appendChild(dateLabel)
				dateField.appendChild(dateValue)

				fieldList.appendChild(nameField);
				fieldList.appendChild(dateField);
				return;
			} else if (fieldData.value === '$placeholder' || !fieldData.value.trim()) {
				value.innerHTML = '---';
			} else if (fieldData.type === 'OPEN_PAYMENT_INPUT') {
				//TODO: Replace hard coded $ with currency variable
				var formattedCost = formatValueToLocale(fieldData.value);
				value.innerHTML = "$ " + formattedCost;
			} else if (fieldData.type === 'TIME_INPUT') {
				// @ts-ignore
				value.innerHTML = moment(fieldData.value, 'HH:mm').format('h:mm a');
			} else if (fieldData.type === 'DATE_INPUT') {
				// @ts-ignore
				value.innerHTML = moment(fieldData.value).format('MM/DD/YYYY');
			} else {
				value.innerText = fieldData.value;
			}
		}

		field.appendChild(label);
		field.appendChild(value);

		fieldList.appendChild(field);
	});

	// Add confirmation email
	if (responseData.confirmationEmailAddress) {
		var field = document.createElement('li');
		field.classList.add('field');

		var label = document.createElement('div');
		label.classList.add('label');

		var value = document.createElement('div');
		value.classList.add('value');

		label.innerHTML = "Confirmation Email"
		value.innerText = responseData.confirmationEmailAddress;

		field.appendChild(label);
		field.appendChild(value);
		fieldList.appendChild(field);
	}
	summaryElement.appendChild(fieldList);

	// Add Order Summary
	if (responseData.orderSummary != "null") {
		var order = document.createElement('footer');
		order.innerHTML = responseData.orderSummary;
		summaryElement.appendChild(order);
	}

	// Add Payment IDs (Edlio order and Receipt IDs)
	if (responseData.paymentAmount) {
		var field = document.createElement('li');
		field.classList.add('field');

		var edlioOrderId = document.createElement('div');
		edlioOrderId.classList.add('value');
		var receiptId = document.createElement('div');
		receiptId.classList.add('value');

        edlioOrderId.innerHTML = "Edlio Order ID: " + responseData.responseId;
        if (responseData.paymentAmount != "0.00" && responseData.paymentAmount != ""){
            var label = document.createElement('div');
            label.classList.add('label');
            label.innerHTML = "Payment"

            field.appendChild(label);
		}

		field.appendChild(edlioOrderId);
		field.appendChild(receiptId);
		paymentInfoBlock.appendChild(field);
		summaryElement.appendChild(paymentInfoBlock);
	}
}

})(window, document);
